import { FlowStepEditor } from "../FlowStepEditor";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { PropertyEditorTextList } from "../../../CommonUI/PropertyEditing/PropertyEditorTextList";
import { FlowExecutionData } from "../../../rule-engine-core/Flow/Engine/FlowExecutionData";
import React from "react";
import { MultiOutputTestStep } from "../../../rule-engine-core/Flow/Steps/ExampleSteps/MultiOutputTestStep";

export class MultiOutputTestStepEditor extends FlowStepEditor<MultiOutputTestStep> {
    renderEditUI(): JSX.Element | null {
        // todo: should not have to observe here
        return (
            <ObserveState
                listenTo={this}
                control={() => {
                    return (
                        <div>
                            <PropertyEditorTextList
                                editObject={this}
                                propertyName={"paths"}
                            />
                        </div>
                    );
                }}
            />
        );
    }

    // eslint-disable-next-line
    start(thread: string, data: FlowExecutionData): void {}
}
